module.exports = __webpack_public_path__ + "static/media/hoverCopyLink.d3229d8f.svg";